import { Component, OnInit, OnDestroy, Inject, HostListener, group } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Router } from '@angular/router';
import { JoyrideService } from 'ngx-joyride';
import * as _ from 'lodash';
/** Import d3 to read elements from the DOM and Create Charts  */
declare const d3: any;
import * as d3Tip from 'd3-tip';
(d3 as any).tip = d3Tip;
import * as moment from 'moment-timezone';
moment.locale('es-US');
moment.tz.setDefault('America/Mexico_City');
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { Indicator } from '../../models/indicator.class';
import { IndicatorEntry } from '../../models/indicatorEntry.class';
import { FormControl } from '@angular/forms';
import { ErrorCatchDialogComponent } from '../../dialogs/error-catch-dialog/error-catch-dialog.component';
import { FilterRadiobuttonPopupComponent } from '../../components/filter-radiobutton-popup/filter-radiobutton-popup.component';
import { UtilsService } from '../../services/utils/utils.service';
import { DataEnadisCompareService } from '../../services/data-enadis-compare/data-enadis-compare.service';
/** Value All to set defaults some filters */
const ALL = 'Todos';
/** Value BOTH to set defaults some filters */
const BOTH = 'Ambos';
/** Value NATIONAL to set defaults some filters */
const NATIONAL = 'Nacional';
/** Value second indicator to set defaults some filters */
const SECOND_INDICATOR_DEFAULT = 'ind5';

/**
 * EnadisCompareGraphsComponent
 * Catch indicator selected and use it to render graphs module
 * Compare data from ENADIS years 2010 and 2017
 */
@Component({
  selector: 'app-enadis-compare-graphs',
  templateUrl: './enadis-compare-graphs.component.html',
  styleUrls: ['./enadis-compare-graphs.component.scss']
})

/** Class EnadisCompareGrahps that implements Methods onIniti anda onDestroy */
export class EnadisCompareGraphsComponent implements OnInit, OnDestroy {
  /** Title of ENaDIS compare component */
  sharetext: string;
  /** True if wanted to share Page  */
  sharePage: boolean;
  /** Contains the value of url string  */
  url: string;
  /** Contains name of image available to download */
  imageJPG: string;
  /** True if wanted to show Slider when loading data of chart */
  showSlider: boolean;
  /** Params to send to API and load the chart*/
  private subQueryParams: any;
  /** Value of indicator  */
  indicator: string;
  /**Value fo all variables  */
  allVariables: Indicator[];
  /** Control for search Variable autocomplete  */
  searchVariable: FormControl;
  /** All filtered variables  */
  filteredVariables: any = [];
  /** Control for searchSecondVariable autocomplete */
  searchSecondVariable: FormControl;
  /** All second filtered variables  */
  filteredSecondVariables: any = [];
  /** value for just selected variable  */
  selectedVariable: Indicator;
  /** value for just second selected variable  */
  secondSelectedVariable: Indicator;
  /** Kind of chart selected  */
  selectedChart: string;
  /** If wanted to stack barchart  */
  stackBy: boolean;
  /** Value of how to order options for a variable  */
  orderBy: string;
  /** True if wanted to show options for colors  */
  showColorsOptions = false;
  /** Boolean when wanted to show filters */
  showFilters = false;
  /** Value of scales applicable to chart  */
  scales: any;
  /* True if clicked to see labels options on chart data */
  showLabelsOptions = false;
  /** Value of chart already rendered on component  */
  drawnChart;
  /** Scatter value if chart type == scatter  */
  backupScatter: any;
  /** Value used when loading data while rendering the chart */
  loadingData = false;
  /** Progress of slider counter while loading data for a chart */
  progress: any;
  /** Number of progress to use in slider while loading data  */
  counter: number;
  /** True if any popup is going to show  */
  showPopup = true;
  /** If there are various filters selected set true */
  multipleFilters: boolean;
  /** True when wanted to display in mobile screen size  */
  switchViewMob = true;
  /** Value of colors available to render chart  */
  colors: string[];
  /** Value fo width of chart  */
  innerWidth: any;
  /** True when component is on a mobile screen size  */
  enableMobileMenu: boolean;
  /** Number of available charts on the componet */
  chartsQuantity: number;
  /** How options could  be sorted */
  sortBy = {
    showSortOptions: false,
    names: true,
    valuesAscending: false,
    valuesDescending: false
  };
  /** True if wanted those Charts available on components*/
  enabledCharts = {
    bars: true,
    heatmap: false,
    spineplot: false,
    timeline: false,
    scatter: false,
    treemap: false,
    map: false
  };
  /** Values of all filters selected  */
  selectedFilters: {};
  /** Data it is going to be setted to a type of chart selected and gonna be rendered  */
  dataToDraw: IndicatorEntry[] = [];
  /** Data whith series of filters to specify an answer  */
  filteredData: IndicatorEntry[] = [];
  /** Object structure to know how to collapse by options */
  collapseBy: { name: string, type: string, slug: string };
  /** Object structure to xAxis  */
  xAxis: { name: string, type: string, slug: string, options: { name: any, slug: any }[] };
  /** Object structure to yAxis  */
  yAxis: { name: string, type: string, slug: string, options: { name: any, slug: any }[] };
  /** Object structure to know how to group options */
  groupedBy: { name: string, type: string, slug: string, options: { name: any, slug: any }[] };
  /** Object structure to general axes options available */
  axisOptions: { name: string, type: string, slug: string, options: { name: string, slug: any }[] }[] = [];
  /** Object structure to xAxis options selected */
  xAxisOptions: { name: string, type: string, slug: string, options: { name: string, slug: any }[] }[] = [];
  /** Object structure to yAxis options selected */
  yAxisOptions: { name: string, type: string, slug: string, options: { name: string, slug: any }[] }[] = [];
  /** Options of how an answer was grouped */
  groupedByOptions: { name: string, type: string, slug: string, options: { name: string, slug: any }[] }[] = [];
  /** Options available to filter an answer  */
  filterOptions: {
    unidad: {
      name: string,
      options: string[],
      selected: string
    }
  };
  /** Second kind of options available top filter an answer  */
  secondFilterOptions: {
    unidad: {
      name: string,
      options: string[],
      selected: string
    }
  };
  /** Info texts are going to be showed on chart  */
  legendOptions: { id?: any, name: string, slug: string, active: boolean }[] = [];
  /** Title of the chart */
  legendTitle: string;
  /** True if wanted to be visible labels of chart  */
  labelsVisible = false;
  /** Value Obtained from DB of title of chart */
  generatedTitle: string;
  /** When wanted to make a subdivition on chart */
  hideSubdivition: boolean;
  /** Value of colors, when question variable has categorical answers */
  categoricalPalettes: string[][];
  /** All colors available to set on chart  */
  availablePalettes: string[][];
  /** Value of colors, when question variable has categorical answers */
  sequentialPalettes: string[][];
  /** Object structure with name of all filters for this component */
  namedFilters: { name: string, slug: string, selected: string }[];
  /** When rotated axes and want to disable Y axis */
  disabledYAxis: boolean;
  /** When rotated axes and want to disable X axis */
  disabledXAxis: boolean;
  /** Value fo filters selected for answer of chart */
  filtersSelected: any;
  /**
   *  Main constuctur for class EnadisCompareGraphs
   * @param route Route used to navigate between all module of enadis
   * @param dbService Service to make request and receive params from a DB
   * @param utils Utilities clases to process data according to needs
   * @param router Route used to navigate between all module of enadis
   * @param dialog When wanted to display a popup, and show some information or activities user can do
   * @param joyrideService Joyride to display just first time chart is rendered
   * @param storage To can use localstorage from browser
   */
  constructor(
    private route: ActivatedRoute,
    private dbService: DataEnadisCompareService,
    public utils: UtilsService,
    private router: Router,
    public dialog: MatDialog,
    private readonly joyrideService: JoyrideService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService) {
  }
  /** Main lyfecicle method of Angular */
  ngOnInit() {
    this.categoricalPalettes = this.utils.getCategoricalColors();
    this.sequentialPalettes = this.utils.getSequentialColors();
    this.disabledXAxis = false;
    this.hideSubdivition = true;
    this.selectedChart = 'bars';
    this.setColorPalette();
    this.chartsQuantity = Object.keys(this.enabledCharts).map(itm => this.enabledCharts[itm]).filter(d => d).length;
    this.allVariables = [];
    this.multipleFilters = true;
    this.counter = 0;
    this.scales = {};
    this.searchVariable = new FormControl();
    this.searchSecondVariable = new FormControl();
    this.sharePage = false;
    this.showSlider = false;
    this.sharetext = 'CONAPRED - ENADIS. Compara 2010 y 2017';
    this.url = 'http://sindis.conapred.org.mx/estadisticas/enadis/'; // Current url to share
    this.stackBy = false;
    this.legendOptions = [];
    this.filterOptions = {
      unidad: {
        name: 'Unidad',
        options: [],
        selected: 'Porcentaje'
      }
    };
    this.secondFilterOptions = {
      unidad: {
        name: 'Unidad',
        options: [],
        selected: 'Porcentaje'
      }
    };
    this.orderBy = 'Año';

    this.subQueryParams = this.route.queryParams.subscribe(params => {
      const indicator = this.route.params['_value'].indicator;
      if (indicator) {
        this.indicator = indicator;
        this.dbService.getCodebook()
          .subscribe(indicators => {
            this.allVariables = indicators.map(i => new Indicator(i));
            this.selectedVariable = this.allVariables.find(d => d.indicator === indicator);
            this.searchVariable.setValue(this.selectedVariable);

            if (this.selectedVariable) {
              this.setOptions();
              this.setAxisOptions();
            } else {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: 'No se encontró el indicador'
                }
              });
            }

            if (params['chart'] && Object.keys(this.enabledCharts).includes(params['chart'])) {
              this.selectedChart = params['chart'];
              this.setColorPalette();
              this.setDefaultAxes();
              this.updateChart();
            } else {
              this.redirect();
            }
            this.disabledYAxis = this.selectedChart === 'bars' ? true : false;
          }, error => {
            console.error(error);
            const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
              panelClass: 'light-themed-dialog',
              width: '400px',
              data: {
                error: error.message.toString() || error.statusText.toString() ||
                  error.error.toString() || error
              }
            });
          });
      }
    });

    this.filteredVariables = this.searchVariable.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.allVariables)) {
            return variable ? this.filterVariables(variable) : this.allVariables.slice();
          } else {
            return [];
          }
        })
      );
    this.filteredSecondVariables = this.searchSecondVariable.valueChanges
      .pipe(
        startWith(''),
        map(variable => {
          if (Array.isArray(this.allVariables)) {
            return variable ? this.filterSecondVariables(variable) : this.allVariables.slice();
          } else {
            return [];
          }
        })
      );
    this.innerWidth = window.innerWidth; // Get screen width for first time
    this.enableMobileMenu = this.innerWidth <= 600 ? true : false; // Enable 'interest variable menu' based on screem width
  }
  /** Generate field's names */
  generateNamedFilters() {
    if (this.selectedFilters && this.selectedVariable) {
      const fields = _.cloneDeep(this.selectedVariable['fieldOptions']);
      this.namedFilters = Object.keys(this.selectedFilters).filter(o => {
        return _.includes(fields.map(f => f.slug), o);
      }).map(function (o) {
        const found = fields.find(f => f.slug === o);
        return {
          name: found.name,
          slug: o,
          selected: this.selectedFilters[o]
        };
      }.bind(this));
    }
  }

  /**
   * Set available color palette, depending on selected chart
   */
  setColorPalette() {
    if (_.includes(['heatmap', 'map'], this.selectedChart)) {
      this.availablePalettes = this.sequentialPalettes;
    } else {
      this.availablePalettes = this.categoricalPalettes;
    }
    this.colors = this.availablePalettes[0];
  }
  /**If palette changed
   * Change the color of the checkboxes
   */
  onPaletteChanged(palette) {
    this.colors = palette;
    this.colorCheckboxes();
  }
  /** Reads the filters selected and update them */
  updateSelectedFilters() {
    const copy = {};
    Object.keys(this.filterOptions).forEach(function (key) {
      copy[key] = this.filterOptions[key].selected;
    }.bind(this));
    return copy;
  }
  /** include Filters according to answer */
  includeFilters() {
    const copy = {};
    Object.keys(this.filterOptions).forEach(function (key) {
      copy[key] = this.filterOptions[key].options;
    }.bind(this));

    if (copy['date']) {
      delete copy['date'];
    }
    return copy;
  }

  /**
   * Generate dynamic title for current chart
   */
  generateTitle() {
    let title = '';
    // Selected indicator
    if (this.selectedChart !== 'scatter' && this.selectedVariable) {
      title += this.selectedVariable.name;
    }
    return title;
  }
  /** Generate text is going to show on chartb selected */
  generateFiltersText() {
    let filtersText = '';
    const keys = Object.keys(this.filterOptions);
    keys.filter(o => o !== 'Fecha').forEach(key => {
      const opt = this.filterOptions[key];
      filtersText += opt.name + ': ';
      filtersText += opt.selected ? opt.selected + ' · ' : ' · ';
    });
    return filtersText;
  }

  /**
   * When x axis is selected
   */
  selectXAxis() {
    // Indicator is 'fila' and selectedChart is 'bars'
    if (this.selectedVariable.kind === 'fila' && this.selectedChart === 'bars') {
      if (this.xAxis.slug === 'category') {
        this.groupedBy = this.groupedByOptions.find(o => o.slug === 'Año');
      } else {
        this.groupedBy = this.groupedByOptions.find(o => o.slug === 'category');
      }
    }
    if (this.filterOptions[this.xAxis.slug] && this.filterOptions[this.xAxis.slug].selected) {
      this.filterOptions[this.xAxis.slug].selected = this.filterOptions[this.xAxis.slug].options[0];
      this.selectedFilters = this.updateSelectedFilters();
    }
    // this.showFilterPopup();
    this.updateChart();
  }

  /**
   * When y axis is selected
   */
  selectYAxis() {
    if (this.selectedChart === 'heatmap') { // Heatmap
      this.groupedBy = Object.assign({}, this.yAxis);
    }
    // this.showFilterPopup();
    this.updateChart();
  }
  /** When changing the kind of bar, if answer has options for axes, display a popup with those options  */
  showFilterPopup() {
    const vm = this;
    const intersection = _.intersection(['columns', 'category'], [this.xAxis.slug, this.yAxis.slug, this.groupedBy]);
    const difference = _.difference(['columns', 'category'], intersection);
    if (intersection.length < 2) {
      if (difference.includes('columns')) {
        this.filterOptions['columns'].selected = this.filterOptions['columns'].selected === 'Todos' ?
          this.filterOptions['columns'].options[1] : this.filterOptions['columns'].selected;
      } else {
        this.filterOptions['columns'].selected = this.filterOptions['columns'].options[0];
      }
      if (difference.includes('category')) {
        this.filterOptions['category'].selected = this.filterOptions['category'].selected === 'Todos' ?
          this.filterOptions['category'].options[1] : this.filterOptions['category'].selected;
      }

      this.selectedFilters = this.updateSelectedFilters();

      const config = this.filtersConfig();
      const selectedFilters = {};
      Object.keys(this.filterOptions).forEach(key => {
        selectedFilters[key] = vm.filterOptions[key].selected;
      });
      const dialogRef = this.dialog.open(FilterRadiobuttonPopupComponent, {
        panelClass: 'white-themed-dialog',
        height: '300px',
        width: '500px',
        data: {
          blocks: difference,
          config: config,
          filterOptions: {
            columns: this.filterOptions['columns'].options.filter(o => !_.includes([ALL, BOTH, NATIONAL], o)),
            category: this.filterOptions['category'].options.filter(o => !_.includes([ALL, BOTH, NATIONAL], o))
          },
          selectedFilters: selectedFilters
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.updateChart();
      });
    } else {
      setTimeout(() => {
        this.updateChart();
      }, 100);
    }
  }
  /** Recieves the value options are going to collapse by  */
  onChangeCollapseBy(factor) {
    this.collapseBy.slug = factor;
  }
  /** When selecting filters didn't wanted to use, call function to get dafault values  */
  onResetFilters() {
    this.setDefaultAxes();
  }
  /** Set default values to Axes, Filters, and options of answer to a variable question
   * Reads type of chart is going to be rendered, and generates answers and options
   */
  setDefaultAxes() {
    if (this.selectedChart !== 'scatter' && this.backupScatter && this.backupScatter.hasOwnProperty('xAxis')) {
      this.xAxis = this.backupScatter.xAxis;
      this.yAxis = this.backupScatter.yAxis;
    }
    if (this.axisOptions.length > 0) {
      this.groupedBy = this.groupedByOptions.find(o => o.slug === '');
      this.generateSelectedFilters();
      this.collapseBy = _.find(this.axisOptions, { type: 'linear' });
      if (this.selectedVariable && this.selectedVariable.kindAnswer !== 0) {
        this.collapseBy = _.find(this.axisOptions, { slug: 'category' });
      }
      switch (this.selectedChart) {
        case 'bars': // Bars
          this.xAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'ordinal' ||
              (o.slug === 'category' && this.selectedVariable.kindAnswer === 1);
          }.bind(this)).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'linear' ||
              (o.slug === 'category' && this.selectedVariable.kindAnswer === 1);
          }.bind(this));

          this.xAxis = _.find(this.xAxisOptions, { slug: 'category' })
            || _.find(this.xAxisOptions, { slug: 'Año' })
            || _.find(this.xAxisOptions, { slug: 'year' })
            || _.find(this.xAxisOptions, { type: 'ordinal' });
          this.yAxis = _.find(this.axisOptions, { slug: this.selectedVariable.collapseBy })
            || _.find(this.axisOptions, { type: 'linear' });
          this.groupedBy = this.groupedByOptions.find(o => o.slug === 'Año') ||
            this.groupedByOptions.find(o => o.slug === '');
          if (this.xAxis.slug === this.groupedBy.slug) {
            this.groupedBy = this.groupedByOptions.find(o => o.slug === '');
          }

          break;
        case 'heatmap': // Heatmap
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.xAxis = _.find(this.axisOptions, { slug: 'category', type: 'ordinal' })
            || _.find(this.axisOptions, { slug: 'columns', type: 'ordinal' }) || _.find(this.xAxisOptions, { slug: 'ENT' });
          this.yAxis = _.find(this.axisOptions, { slug: 'RANGO_EDAD' });
          if (this.yAxis) {
            this.groupedBy = Object.assign({}, this.yAxis);
          }
          break;
        case 'spineplot': // Spineplotthis.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal' );
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'ordinal').sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(function (o) {
            return o.type === 'ordinal' ||
              (this.filterOptions.unidad.selected === 'Promedio' && this.selectedVariable.kindAnswer !== 0 ?
                o.slug === 'category' : o.slug === this.selectedVariable.collapseBy);
          }.bind(this)).sort((a, b) => a.name < b.name ? -1 : 1);

          this.xAxis = _.find(this.xAxisOptions, { slug: 'RANGO_EDAD', type: 'ordinal' });
          this.yAxis = _.find(this.yAxisOptions, { slug: 'category' }) ||
            _.find(this.axisOptions, { slug: 'columns', type: 'ordinal' }) ||
            _.find(this.axisOptions, { type: 'ordinal' });

          if (this.yAxis) {
            this.groupedBy = Object.assign({}, this.yAxis);
            // this.xAxisGroupBy = _.find(this.groupByItems, {slug: this.groupedBy});
          }

          if (this.yAxis.slug === this.xAxis.slug) {
            this.xAxis = _.find(this.xAxisOptions, { type: 'ordinal' });
          }
          break;
        case 'scatter': // Scatter
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
          this.xAxis = _.find(this.axisOptions, { slug: 'category' });
          this.backupScatter = {
            xAxis: _.clone(this.xAxis),
            yAxis: _.clone(this.yAxis)
          };
          this.yAxis.name = this.selectedVariable.name;
          this.yAxis.slug = this.selectedVariable.name;
          this.groupedBy = this.groupedByOptions.find(o => o.slug === 'Año');
          // this.xAxisGroupBy = _.find(this.groupByItems, {slug: this.groupedBy});

          this.xAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = [this.yAxis];

          if (this.allVariables && this.allVariables.length > 0) {
            this.secondSelectedVariable = this.allVariables[0];
            this.searchSecondVariable.setValue(this.secondSelectedVariable);
            this.xAxis = Object.assign({}, this.axisOptions.find(o => o.slug === 'Año'));
          }

          if (this.secondSelectedVariable) {
            this.setSecondOptions();
          }

          break;
        case 'timeline': // Timeline
          this.xAxisOptions = this.axisOptions.filter(o => o.slug === 'year');
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'linear');
          this.xAxis = _.find(this.axisOptions, { slug: 'year' });
          this.yAxis = _.find(this.axisOptions, { slug: 'category', type: 'linear' })
            || _.find(this.axisOptions, { slug: this.selectedVariable.collapseBy });

          if (this.selectedVariable && this.selectedVariable.kind === 'columna') {
            if (this.selectedVariable.kindAnswer !== 0) {
              this.filterOptions['category'].selected = this.filterOptions['category'].options[1] !== undefined ?
                this.filterOptions['category'].options[1] : ALL;
            }
            this.groupedBy = this.groupedByOptions.find(o => o.slug === 'columns');
            this.filterOptions['columns'].selected = ALL;
          } else {
            this.groupedBy = this.groupedByOptions.find(o => o.slug === 'category');

          }
          break;
        case 'map': // Map
          this.xAxisOptions = this.axisOptions.filter(o => o.type === 'geography');
          this.xAxis = this.xAxisOptions[0];
          this.filterOptions[this.xAxis.slug].selected = NATIONAL;
          this.yAxisOptions = this.axisOptions.filter(o => o.type === 'linear');
          this.yAxis = _.find(this.axisOptions, { slug: 'category', type: 'linear' })
            || _.find(this.axisOptions, { slug: this.selectedVariable.collapseBy });
          // this.selectedFilters.year = ALL;
          this.groupedBy = this.groupedByOptions.find(o => o.slug === '');
          break;
        default:
          this.xAxis = _.find(this.axisOptions, { slug: 'category' });
          this.yAxis = _.find(this.axisOptions, { slug: 'RANGO_EDAD' });
          this.xAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          this.yAxisOptions = this.axisOptions.filter(o => o).sort((a, b) => a.name < b.name ? -1 : 1);
          break;
      }
    }

    if (this.selectedVariable && this.selectedVariable.kind === 'columna' &&
      this.xAxis && this.xAxis.slug !== 'columns' && this.selectedChart !== 'timeline') {
      this.filterOptions['columns'].selected = ALL;
      this.groupedBy = this.groupedByOptions.find(o => o.slug === 'columns');
    }

    if (this.selectedChart === 'map') {
      const lastYear = this.filterOptions['year'].options.length - 1;
      this.filterOptions['category'].selected = this.filterOptions['category'].options[2] !== undefined ?
        this.filterOptions['category'].options[2] : ALL;
    }
    this.selectedFilters = this.updateSelectedFilters();
  }

  /**
   * Reads axes and type of chart and
   * Set collapseBy column if wanted
   */
  checkAxesSelected() {
    switch (this.selectedChart) {
      case 'bars': // Bars
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis && this.yAxis.type === 'ordinal' && this.xAxis && this.xAxis.type === 'ordinal') {
          this.yAxis = _.find(this.axisOptions, { slug: 'category', type: 'linear' })
            || _.find(this.axisOptions, { type: 'linear' });
        }
        if (this.yAxis && this.yAxis.type === 'linear' && this.xAxis && this.xAxis.type === 'linear') {
          this.xAxis = _.find(this.axisOptions, { type: 'ordinal' });
        }
        break;
      case 'heatmap': // Heatmap
        if (this.yAxis.type === 'linear') {
          this.yAxis = _.find(this.axisOptions.reverse(), { type: 'ordinal' });
        }
        if (this.xAxis.type === 'linear') {
          if (this.xAxis.slug === 'category' && this.filterOptions['unidad'].selected !== 'Promedio') {
            this.xAxis.type = 'ordinal';
          } else {
            this.xAxis = _.find(this.axisOptions, { type: 'ordinal' });
          }
        }
        break;
      case 'spineplot': // Spineplot
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis.type === 'linear' && this.xAxis.type === 'linear') {
          this.xAxis = _.find(this.axisOptions, { slug: 'RANGO_EDAD' });
        }
        if (this.yAxis.type !== 'linear') {
          this.groupedBy = Object.assign({}, this.yAxis);
        }
        break;
      case 'scatter': // Scatter
        break;
      case 'timeline': // Timeline
        this.xAxis = _.find(this.axisOptions, { slug: 'year' });
        if (this.yAxis.type !== 'linear') {
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
        }
        break;
      case 'map':
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        this.xAxis = _.find(this.xAxisOptions, { slug: 'ENT' });
        if (this.yAxis.type !== 'linear') {
          this.yAxis = _.find(this.axisOptions, { type: 'linear' });
        }
        break; // Map
      default:
        /** if selected axis variable is ordinal, the other one MUST be linear for bars */
        if (this.yAxis.type === 'ordinal' && this.xAxis.type === 'ordinal') {
          this.yAxis = _.find(this.axisOptions, { slug: this.selectedVariable.collapseBy });
        }
        break;
    }

    const linearAxis = _.find([this.yAxis, this.xAxis], { 'type': 'linear' });
    this.collapseBy = linearAxis ? linearAxis :
      this.filterOptions['unidad'].selected === 'Promedio' && this.selectedVariable.kindAnswer !== 0 ?
        _.find(this.axisOptions, { slug: 'category' }) : _.find(this.axisOptions, { slug: this.selectedVariable.collapseBy });
  }
  /**
   * Reads how many filters were selected, validate not more than 2 if more Display alert message.
   * @param filters Filters selected by user
   */
  validateFilters(filters) {
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], filters[this.groupedBy.slug])) {
      this.groupedBy = this.groupedByOptions.find(o => o.slug === '');
    }
    const keys = Object.keys(filters);
    const values = Object.keys(filters).map(itm => filters[itm]);
    const filtered = values.filter(o => !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], o));

    if (filtered.length > 2) {
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'No es posible seleccionar más de dos filtros, por favor cambia tu selección'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }
  /**
   * Once filters have got selected, read them and update chart according to selected
   * @param filters Filters selected by user
   */
  updateFilters(filters) {
    this.showFilters = false;
    this.groupedBy = this.groupedByOptions.find(o => o.slug === 'Año');
    if (this.groupedBy && !_.includes([ALL, BOTH, NATIONAL], filters[this.groupedBy.slug])) {
      this.groupedBy = this.groupedByOptions.find(o => o.slug === '');
    }
    if (filters) {
      this.filtersSelected = filters;
    }
    const keys = Object.keys(filters);
    const values = Object.keys(filters).map(itm => filters[itm]);
    const filtered = values.filter(o => !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], o));

    if (filtered.length > 2) {
      const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
        panelClass: 'light-themed-dialog',
        width: '400px',
        data: {
          error: 'No es posible seleccionar más de dos filtros, por favor cambia tu selección'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    } else {
      setTimeout(() => {
        this.updateChart();
      }, 100);
    }
  }

  /**
   * Get initial options from selected indicator
   */
  setOptions() {
    this.axisOptions = [
      { name: this.selectedVariable.name, slug: this.selectedVariable.collapseBy, type: 'linear', options: undefined }
    ];
    this.filterOptions = {
      unidad: {
        name: 'Unidad',
        options: [],
        selected: 'Porcentaje'
      },
    };
    if (this.selectedVariable.total) {
      this.filterOptions.unidad.options.push('Total');
    }
    if (this.selectedVariable.average) {
      this.filterOptions.unidad.options.push('Promedio');
    }
    if (this.selectedVariable.percentage) {
      this.filterOptions.unidad.options.push('Porcentaje');
    }
    if (this.selectedVariable.rate) {
      this.filterOptions.unidad.options.push('Tasa');
    }
    if (this.selectedVariable.index) {
      this.filterOptions.unidad.options.push(this.selectedVariable.indexName);
    }
    this.filterOptions.unidad.selected = this.filterOptions.unidad.options[0];
    if (this.selectedVariable.fieldOptions) {
      for (let index = 0; index < this.selectedVariable.fieldOptions.length; index++) {
        const fieldOption = this.selectedVariable.fieldOptions[index];
        const filterAbv = fieldOption['slug'];
        let dbOpts;
        let completeOpts;

        this.axisOptions.push(fieldOption);

        dbOpts = _.uniq(fieldOption['options'].map(d => d['name']).sort());

        if (filterAbv === 'SEXO') {
          completeOpts = [BOTH].concat(dbOpts as string[]);
        } else if (filterAbv === 'ENT') {
          completeOpts = [NATIONAL].concat(dbOpts as string[]);
        } else {
          completeOpts = [ALL].concat(dbOpts as string[]);
        }
        this.filterOptions[filterAbv] = {
          name: fieldOption.name,
          slug: fieldOption.slug,
          options: completeOpts,
          selected: completeOpts[0]
        };
      }
    }

    this.secondSelectedVariable = this.allVariables[0];
    this.searchSecondVariable.setValue(this.allVariables[0]);

    if (this.allVariables && this.allVariables.length > 0) {
      this.secondSelectedVariable = this.allVariables[0];
      this.searchSecondVariable.setValue(this.secondSelectedVariable);
    }

    if (this.secondSelectedVariable && !this.secondFilterOptions) {
      this.setSecondOptions();
    }

    const salaries = ['Sin ingresos',
      'Menos de 1 Salario mínimo',
      '1-2 Salarios mínimos',
      '2-3 Salarios mínimos',
      '3-4 Salarios mínimos',
      '4-5 Salarios mínimos',
      '5-6 Salarios mínimos',
      '6-7 Salarios mínimos',
      'Más de 7 Salarios mínimos',
      '8-9 Salarios mínimos',
      '9-10 Salarios mínimos',
      '10 o más Salarios mínimos'];

    const situation = [
      'Siempre',
      'Algunas veces',
      'Pocas veces',
      'Nunca',
      'No responde'];

    const education = [
      'Sin escolaridad',
      'Preescolar',
      'Primaria incompleta',
      'Primaria',
      'Secundaria incompleta',
      'Secundaria',
      'Media superior',
      'Superior',
      'No sabe'];

    const frequency = [
      'Mucho',
      'Algo',
      'Poco',
      'Nada',
      'No Sabe',
      'No aplica'];

    const quantity = [
      'Mucha',
      'Alguna',
      'Poca',
      'Nada',
      'No sabe'];

    this.collapseBy = this.selectedVariable.kindAnswer === 0 ?
      this.axisOptions.find(o => o.slug === this.selectedVariable.collapseBy) :
      this.axisOptions.find(o => o.slug === 'category');

    this.generateSelectedFilters();
    this.setAxisOptions();
    this.generateGroupItems();
    this.setDefaultAxes();
    this.updateChart();
  }
  /** Sets Additional options for Variable Question, like Total, Promedio, Tasa, etc  */
  setSecondOptions() {
    this.secondFilterOptions = {
      unidad: {
        name: 'Unidad',
        options: [],
        selected: 'Porcentaje'
      }
    };
    if (this.secondSelectedVariable.total) {
      this.secondFilterOptions.unidad.options.push('Total');
    }
    if (this.secondSelectedVariable.average) {
      this.secondFilterOptions.unidad.options.push('Promedio');
    }
    if (this.secondSelectedVariable.percentage) {
      this.secondFilterOptions.unidad.options.push('Porcentaje');
    }
    if (this.secondSelectedVariable.rate) {
      this.secondFilterOptions.unidad.options.push('Tasa');
    }
    if (this.secondSelectedVariable.index) {
      this.secondFilterOptions.unidad.options.push(this.secondSelectedVariable.indexName);
    }
    this.secondFilterOptions.unidad.selected = this.secondFilterOptions.unidad.options[0];
    this.selectedFilters = this.updateSelectedFilters();
    if (this.secondSelectedVariable.fieldOptions) {
      for (let index = 0; index < this.secondSelectedVariable.fieldOptions.length; index++) {
        const fo = this.secondSelectedVariable.fieldOptions[index];
        const filterAbv = fo['slug'];
        let dbOpts;
        let completeOpts;

        dbOpts = _.uniq(fo['options'].map(d => d['name']).sort());

        if (filterAbv === 'SEXO') {
          completeOpts = [BOTH].concat(dbOpts as string[]);
        } else if (filterAbv === 'ENT') {
          completeOpts = [NATIONAL].concat(dbOpts as string[]);
        } else {
          completeOpts = [ALL].concat(dbOpts as string[]);
        }
        this.secondFilterOptions[filterAbv] = {
          name: fo.name,
          slug: fo.slug,
          options: completeOpts,
          selected: completeOpts[0]
        };
      }
    }
  }
  /** Set the values for Both Axes for first instace  */
  setAxisOptions() {
    const vm = this;
    const collapseBy = this.selectedVariable.collapseBy || 'value';

    this.axisOptions = [
      { name: 'Cantidad de personas', slug: collapseBy, type: 'linear', options: null }
    ];

    for (let index = 0; index < this.selectedVariable.fieldOptions.length; index++) {
      const opt = this.selectedVariable.fieldOptions[index];
      vm.axisOptions.push(opt);
    }
  }

  /**
   * Sets the selected groupBy in the drowpdown
   * @param xAxisGroupBy How xAxis are going to group by
   */
  selectXAxisGroupBy(xAxisGroupBy: { name: string, type: string, slug: string, options: { name: any, slug: any }[] }) {
    this.groupedBy = xAxisGroupBy;
    this.groupBy(this.groupedBy);
  }
  /**
   * Reads How xAxis are going to group by and send to selectXAxisGroupBy function
   */
  onSelectXAxisGroupBy() {
    this.selectXAxisGroupBy(this.groupedBy);
  }
  /**
   * Reads type of chart selected and groups according to it
   * @param item The option of grouping selected
   */
  groupBy(item: { name: string, type: string, slug: string, options: { name: any, slug: any }[] }) {
    const vm = this;
    if (!((this.xAxis && item.slug === this.xAxis.slug) || ((this.yAxis &&
      item.slug === this.yAxis.slug) && this.selectedChart === 'bars'))) {
      this.groupedBy = item;
      if (item && item.slug) {
        this.filterOptions[item.slug].selected = this.filterOptions[item.slug].options[0];
        this.selectedFilters = this.updateSelectedFilters();
      }
    }
    if (this.selectedChart === 'heatmap') { // Heatmap
      if (item) {
        this.yAxis = _.find(this.yAxisOptions, { slug: this.groupedBy.slug });
      } else {
        this.yAxis = _.find(this.yAxisOptions, { type: 'ordinal' });
        this.groupedBy = this.groupedByOptions.find(o => o.slug === vm.yAxis.slug);
      }
    }
    if (this.selectedChart === 'spineplot') { // Spineplot
      if (item) {
        this.yAxis = _.find(this.yAxisOptions, { slug: this.groupedBy.slug });
      } else {
        this.yAxis = Object.assign({ options: [] }, this.collapseBy);
      }
    }
    if (this.selectedChart === 'map') {
      this.groupedBy = this.groupedByOptions.find(o => o.slug === '');
    }
    // this.showFilterPopup();
    this.updateChart();
  }
  /**
   * Receives the groups made by options selected
   */
  getGroupedByOptions() {
    if (this.groupedBy && this.groupedBy.options && this.groupedBy.options.length > 0) {
      return this.groupedBy.options.map((o: { name: any, slug: any }) => o.name + '');
    } else {
      return [];
    }
  }
  /** Gets an array containing all filter options available by chart  */
  getFilterOptionsAsArray() {
    return Object.keys(this.filterOptions).map(itm => this.filterOptions[itm]);
  }

  /*
  filterByAcotarVariable() {
    // setTimeout(() => {
    const dataToDraw = this.dataToDraw.filter(function (d) {
      const linearCol = this.collapseBy.slug;
      return d[linearCol] >= this.acotarVariable[0] && d[linearCol] <= this.acotarVariable[1];
    }.bind(this));
    this.setLegendOptions(dataToDraw);
    this.drawChart(dataToDraw);
    // }, 1000);
  }
  */

  /**
   * Reads options and filters selected, and assign to chart to render it on the component
   * Default type of chart is BarChart, calls functions to get Titles and value fo axes
   * calls dbService to get info from DataBase
   */
  updateChart() {
    const vm = this;
    this.generatedTitle = this.generateTitle();
    // Show loading text while updating chart
    d3.select('.empty-chart').selectAll('*').remove();
    d3.selectAll('.d3-tip').remove();
    d3.selectAll('.title-tip').remove();
    d3.select('.empty-chart').text('CARGANDO GRÁFICA...');
    if (this.selectedChart && this.selectedVariable && this.xAxis && this.yAxis) {
      this.checkAxesSelected();
      this.generateNamedFilters();
      /**
       * redraw selected chart
       * Get data to draw chart
       */
      let selectedFilters = {};
      if (this.filtersSelected) {
        selectedFilters = this.filtersSelected;
      } else {
        Object.keys(this.filterOptions).forEach(key => {
          selectedFilters[key] = vm.filterOptions[key].selected;
        });
      }
      const xAxis = this.xAxis.slug;
      let yAxis = this.yAxis.slug;
      let groupedBy = this.groupedBy.slug;
      const collapseBy = this.collapseBy.slug;
      const project = {};
      if ((this.selectedChart === 'scatter' || this.selectedChart === 'heatmap') && groupedBy) { // Scatter
        project[groupedBy] = 1;
        groupedBy = '';
      }
      if (this.selectedChart === 'spineplot') { // Spineplot
        yAxis = this.collapseBy.slug;
      }
      const keys = {
        xAxis: xAxis,
        yAxis: yAxis,
        groupBy: groupedBy,
        project: project,
        collapseBy: collapseBy
      };

      if (this.selectedChart === 'map') { // Map
        this.generateSelectedFilters();

        const filters = Object.keys(selectedFilters);
        const values = Object.keys(selectedFilters).map(itm => selectedFilters[itm]);
        const filteredValues = values.filter(function (obj) {
          return !_.includes([ALL, BOTH, NATIONAL, 'Total', 'Porcentaje', 'Promedio'], obj);
        });
        for (let index = 0; index < filteredValues.length; index++) {
          const element = filteredValues[index];
          const idx = values.indexOf(element);
          keys.project[filters[idx]] = 1;
        }
      }

      if (this.selectedChart !== 'scatter') {
        this.loadingData = true;
        this.progress = setInterval(function () {
          if (vm.counter < 92) {
            vm.counter += Math.floor(Math.random() * (5 - 0 + 1)) + 0;
          }
        }, 600);
        this.dbService.getDataToDraw(this.indicator, selectedFilters, keys, 'mensual')
          .subscribe(dataToDraw => {
            d3.select('.empty-chart')
              .style('border', null)
              .text('');
            if (dataToDraw.length === 0) {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: 'No existen datos para esta pregunta'
                }
              });
              dialogRef.afterClosed().subscribe(result => {
                d3.select('.empty-chart')
                  .style('border', 'dashed 2px #ccc')
                  .text('NO EXISTEN DATOS PARA ESTA PREGUNTA');
              });
            }
            clearInterval(this.progress);
            this.counter = 0;
            this.loadingData = false;
            this.dataToDraw = dataToDraw;

            this.sortChanged('names');
            // this.startJoyride();

          }, error => {
            console.error(error);
            const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
              panelClass: 'light-themed-dialog',
              width: '400px',
              data: {
                error: error.message || error.statusText || error.error || error
              }
            });
            dialogRef.afterClosed().subscribe(result => {
              clearInterval(this.progress);
              this.counter = 0;
              this.loadingData = false;
              this.redirect();
            });
          });
      } else {
        if (this.secondSelectedVariable && this.selectedVariable) {
          const firstIndicator = {
            indicator: this.indicator,
            units: selectedFilters['unidad'],
            selectedFilters: selectedFilters,
            keys: {
              xAxis: xAxis,
              yAxis: this.selectedVariable.collapseBy,
              groupBy: groupedBy,
              collapseBy: this.selectedVariable.collapseBy,
              project: project
            }
          };

          const secondSelectedFilters = {};
          Object.keys(this.secondFilterOptions).forEach(key => {
            secondSelectedFilters[key] = vm.secondFilterOptions[key].selected;
          });
          if (secondSelectedFilters['date'] === ALL) {
            delete secondSelectedFilters['date'];
          }
          const secondSelectedIndicator = {
            indicator: this.secondSelectedVariable.indicator,
            units: secondSelectedFilters['unidad'],
            selectedFilters: secondSelectedFilters,
            keys: {
              xAxis: xAxis,
              yAxis: this.secondSelectedVariable.collapseBy,
              groupBy: groupedBy,
              collapseBy: this.secondSelectedVariable.collapseBy,
              project: project
            }
          };
          this.dbService.crossData(firstIndicator, secondSelectedIndicator)
            .subscribe(dataToDraw => {
              d3.select('.empty-chart')
                .style('border', null)
                .text('');
              if (dataToDraw.length === 0) {
                const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                  panelClass: 'light-themed-dialog',
                  width: '400px',
                  data: {
                    error: 'No existen datos para este cruce, cambia la segunda variable'
                  }
                });
                dialogRef.afterClosed().subscribe(result => {
                  d3.select('.empty-chart')
                    .style('border', 'dashed 2px #ccc')
                    .text('NO EXISTEN DATOS PARA ESTE CRUCE, CAMBIA LA SEGUNDA VARIABLE');
                });
              }
              clearInterval(this.progress);
              this.counter = 0;
              this.loadingData = false;
              this.dataToDraw = dataToDraw;

              this.backupScatter = {
                xAxis: _.cloneDeep(this.xAxis),
                yAxis: _.cloneDeep(this.yAxis),
                groupedBy: _.cloneDeep(this.groupedBy),
                axisOptions: _.cloneDeep(this.axisOptions)
              };

              this.xAxis.name = this.secondSelectedVariable.name;
              this.xAxis.slug = this.secondSelectedVariable.name;
              this.xAxis.type = 'linear';
              this.yAxis.name = this.selectedVariable.name;
              this.yAxis.slug = this.selectedVariable.name;
              this.yAxis.type = 'linear';

              this.sortChanged('names');
            }, error => {
              const dialogRef = this.dialog.open(ErrorCatchDialogComponent, {
                panelClass: 'light-themed-dialog',
                width: '400px',
                data: {
                  error: error.message || error.statusText || error.error || error
                }
              });
              dialogRef.afterClosed().subscribe(result => {
                clearInterval(this.progress);
                this.counter = 0;
                this.loadingData = false;
                this.redirect();
              });
            });
        }
      }
    }
  }
  /**
   * Gets the Filters and options for an answer of variable qu3estion
   * Redirects to /content/compara-enadis/ with vvalues obbtained
   */
  redirect() {
    const queryParams = {
      chart: this.selectedChart
    };
    if (this.filterOptions['date'] && this.filterOptions['date'].selected && moment(this.filterOptions['date'].selected).isValid()) {
      queryParams['dateStart'] = moment(this.filterOptions['date'].selected).toISOString();
    } else {
      if (this.filterOptions['dateStart'] && this.filterOptions['dateStart'].selected &&
        moment(this.filterOptions['dateStart'].selected).isValid()) {
        queryParams['dateStart'] = moment(this.filterOptions['dateStart'].selected).toISOString();
      } else if (this.filterOptions['date'] && this.filterOptions['date'].options.length > 1) {
        queryParams['dateStart'] = moment(this.filterOptions['date'].options[1]).toISOString();
      }
      if (this.filterOptions['dateEnd'] && this.filterOptions['dateEnd'].selected &&
        moment(this.filterOptions['dateEnd'].selected).isValid()) {
        queryParams['dateEnd'] = moment(this.filterOptions['dateEnd'].selected).toISOString();
      } else if (this.filterOptions['date'] && this.filterOptions['date'].options.length > 1) {
        queryParams['dateEnd'] = moment(_.clone(this.filterOptions['date'].options).pop()).toISOString();
      }
    }

    if (this.selectedChart === 'scatter') {
      if (this.secondSelectedVariable || this.allVariables.filter(function (indicator) {
        if (this.selectedIndicator) {
          return indicator.geography === BOTH || indicator.geography === this.selectedIndicator.geography;
        }
      }.bind(this)).length > 0) {
        queryParams['secondIndicator'] = this.secondSelectedVariable ?
          this.secondSelectedVariable.indicator : (SECOND_INDICATOR_DEFAULT || this.allVariables[0].indicator);
      }
      if ((this.secondFilterOptions['dateStart'] && this.secondFilterOptions['dateStart'].selected) ||
        (this.secondFilterOptions['date'] && this.secondFilterOptions['date'].selected &&
          moment(this.secondFilterOptions['date'].selected).isValid())) {
        queryParams['secondDateStart'] = moment(this.secondFilterOptions['dateStart'].selected).toISOString() ||
          moment(this.secondFilterOptions['date'].selected).toISOString();
      }
      if (this.secondFilterOptions['dateEnd'] && this.secondFilterOptions['dateEnd'].selected) {
        queryParams['secondDateEnd'] = moment(this.secondFilterOptions['dateEnd'].selected).toISOString();
      }
    }
    this.router.navigate(['/content/compara-enadis/' + this.indicator], {
      queryParams: queryParams
    });
  }
  /**
   * Reads joyrideDone on localStorage if its true dónt display anymore
   * Display a tour on the component with hints about how to use it, just if it is the first time visualizing the component
   */
  startJoyride() {
    if (!this.storage.get('joyrideDone')) {
      this.joyrideService.startTour(
        {
          steps: ['step1', 'step2', 'step3', 'step4', 'step5', 'step6'],
          stepDefaultPosition: 'top',
        } // Your steps order
      ).subscribe(
        (step) => { /*Do something*/ },
        (error) => { /*handle error*/ },
        () => {
          /*Tour is finished here */
          this.storage.set('joyrideDone', true);
        }
      );
    }
  }
  /**
   * Reads everytime a Variable question was changed
   * @param indicator Variable selected
   */
  onIndicatorChange(indicator) {
    this.selectedVariable = indicator;
    this.redirect();
  }
  /**
   * Reads data selected like filters, type of chart and options selected
   * Process data and generate which is going to be displayed on Chart
   * @param data Data selected, and is going to be displayed on chart
   * @param considerLegendOptions Optional, just need if legendoptions are going to be showed
   */
  parseData(data, considerLegendOptions?) {
    /**
     * Sort data by this.orderBy
     */
    let resultData = _.cloneDeep(data).sort(function (a, b) {
      if (this.filterOptions[this.orderBy] && _.includes(this.filterOptions[this.orderBy].options, a[this.orderBy]) &&
        _.includes(this.filterOptions[this.orderBy].options, b[this.orderBy])) {
        const res = ['No', 'Sí'];
        return this.filterOptions[this.orderBy].options.indexOf(a[this.orderBy])
          - this.filterOptions[this.orderBy].options.indexOf(b[this.orderBy]);
      } else if (a[this.orderBy] === 'Otro' || a[this.orderBy] === 'No aplica') {
        return 1;
      } else if (b[this.orderBy] === 'Otro' || b[this.orderBy] === 'No aplica') {
        return -1;
      } else {
        if (this.sortBy.valuesAscending === true) {
          if (!Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            // If both values are numbers use numeric value
            return Number(a[this.orderBy]) - Number(b[this.orderBy]);
          } else if (!Number.isNaN(+a[this.orderBy]) && Number.isNaN(+b[this.orderBy])) {
            return -1;
          } else if (Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            return 1;
          } else if (a[this.orderBy] <= b[this.orderBy]) {
            return -1;
          } else {
            return 1;
          }
        } else if (this.sortBy.valuesDescending === true) {
          if (!Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            // If both values are numbers use numeric value
            return Number(b[this.orderBy]) - Number(a[this.orderBy]);
          } else if (!Number.isNaN(+a[this.orderBy]) && Number.isNaN(+b[this.orderBy])) {
            return 1;
          } else if (Number.isNaN(+a[this.orderBy]) && !Number.isNaN(+b[this.orderBy])) {
            return -1;
          } else if (a[this.orderBy] <= b[this.orderBy]) {
            return 1;
          } else {
            return -1;
          }
        }
      }
    }.bind(this)).filter(function (d) {
      return (!this.xAxis || this.xAxis && !this.filterOptions[this.xAxis.slug] || this.xAxis && this.xAxis.type === 'linear' ||
        this.xAxis && _.includes(this.filterOptions[this.xAxis.slug].options.map(o => o + ''), d[this.xAxis.slug] + '')
        || this.selectedFilters.ENT === NATIONAL) &&
        (!this.yAxis || this.yAxis && !this.filterOptions[this.yAxis.slug] || this.yAxis && this.yAxis.type === 'linear' || this.yAxis &&
          this.filterOptions[this.yAxis.slug] &&
          _.includes(this.filterOptions[this.yAxis.slug].options.map(o => o + ''), d[this.yAxis.slug] + '')) ||
        this.yAxis && (this.groupedBy && this.yAxis.slug === this.groupedBy);
    }.bind(this));

    /**
     * Adapt data for each chart
     */
    switch (this.selectedChart) {
      case 'bars':
        if ((this.xAxis && this.xAxis.slug === 'value' && this.xAxis.type === 'linear') ||
          (this.yAxis && this.yAxis.slug === 'value' && this.yAxis.type === 'linear')) {
          resultData = resultData.filter(function (d) {
            if (d.year) {
              d.year += '';
            }
            return !Number.isNaN(d['value']);
          });
        } else {
          resultData = resultData.map(function (d) {
            d.year += '';
            return d;
          });
        }
        resultData = resultData.map(function (obj) {
          // If spineplot is grouped by municipality
          if (this.groupedBy === 'ENT' && obj['ENT'] === 'Fuera AMM') {
            obj['ENT'] = 'Fuera del Área Metropolitana de Monterrey';
          }
          return obj;
        }.bind(this));
        break;
      case 'heatmap': // Heatmap
        resultData = resultData.map(function (d) {
          if (d.year) {
            d.year += '';
          }
          // If heatmap is grouped by municipality
          if (this.groupedBy === 'ENT' && d['ENT'] === 'Fuera AMM') {
            d['ENT'] = 'Fuera del Área Metropolitana de Monterrey';
          }
          return d;
        }.bind(this));
        break;
      case 'spineplot': // Spineplot
        resultData = resultData.map(function (obj) {
          if (obj.year) {
            obj.year += '';
          }
          // If spineplot is grouped by municipality
          if (this.groupedBy === 'ENT' && obj['ENT'] === 'Fuera AMM') {
            obj['ENT'] = 'Fuera del Área Metropolitana de Monterrey';
          }
          return obj;
        }.bind(this));
        break;
      case 'timeline': // Timeline
        // Parse year as date
        resultData = resultData.map(function (d) {
          d.year = ('' + d.year).slice(0, 4) + '-01-01';
          return d;
        });
        break;
      case 'map': // Map
        const filters = Object.keys(this.filterOptions).filter(o => o !== 'unidad' && o !== 'ENT');
        const collapseBy = this.collapseBy.slug;
        const totals = {};
        _.uniq(resultData.map(o => o.ENT) as string[]).forEach(function (mpo) {
          totals[mpo] = d3.sum(resultData.filter(o => o.ENT === mpo), function (o) {
            return o[collapseBy];
          });
        });

        resultData = resultData.filter(function (obj) {
          obj.total = totals[obj.ENT];
          let result = true;
          filters.forEach(function (key) {
            if (obj[key] && this.selectedFilters[key] && this.collapseBy.slug !== key) {
              result = result && obj[key] === this.selectedFilters[key];
            }
          }.bind(this));
          return result;
        }.bind(this));

        let newData = [];
        const GeoUnits = this.filterOptions['ENT'].options.map(g => g.toUpperCase().replace('Á', 'A').replace('Í', 'I'));

        const NuevoLeon = this.filterOptions['unidad'].selected === 'Promedio' ?
          d3.sum(resultData, o => o[collapseBy] * o.factor_expansion) / d3.sum(resultData, o => o.factor_expansion) :
          d3.sum(resultData, o => o[collapseBy]);
        const NuevoLeonTotal = d3.sum(resultData, o => o.total);
        const AMM = this.filterOptions['unidad'].selected === 'Promedio' ?
          d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o[collapseBy] * o.factor_expansion) /
          d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o.factor_expansion) :
          d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o[collapseBy]);
        const AMMTotal = d3.sum(resultData.filter(o => o.ENT !== 'Fuera AMM'), o => o.total);
        const FAMM = this.filterOptions['unidad'].selected === 'Promedio' ?
          d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o[collapseBy] * o.factor_expansion) /
          d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o.factor_expansion) :
          d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o[collapseBy]);
        const FAMMTotal = d3.sum(resultData.filter(o => o.ENT === 'Fuera AMM'), o => o.total);

        const Muns = resultData.filter(function (obj) {
          return _.includes(GeoUnits, obj.ENT.toUpperCase().replace('Á', 'A').replace('Í', 'I'));
        }).map(function (obj) {
          obj.id = this.municipalitiesIds[obj.ENT];
          obj.name = obj.ENT;
          return obj;
        }.bind(this));

        const NUEVOLEON = { id: 18, name: NATIONAL, total: NuevoLeonTotal };
        NUEVOLEON[collapseBy] = NuevoLeon;
        newData.push(NUEVOLEON);
        const AMMObj = { id: 1, name: 'Área Metropolitana de Monterrey', total: AMMTotal };
        AMMObj[collapseBy] = AMM;
        newData.push(AMMObj);
        const FUERAAMM = { id: 0, name: 'Fuera del Área Metropolitana de Monterrey', total: FAMMTotal };
        FUERAAMM[collapseBy] = FAMM;
        newData.push(FUERAAMM);
        newData = newData.concat(Muns);
        resultData = newData;
        break;
      default:
        resultData = resultData;
        break;
    }
    /**
     * Filter data by legend options active
     */
    resultData = resultData.filter(function (d) {
      if (considerLegendOptions) {
        if (this.selectedChart === 'map') {
          return this.legendOptions.filter(o => o.active).map(o => o.id).includes(d.id);
        } else {
          let slug = '';
          if (this.groupedBy) {
            if (this.selectedChart === 'scatter') { // Scatter
              slug = this.groupedBy;
            }
            const unCheckedNames = this.legendOptions.filter(o => !o.active).map(o => o.name);
            for (let index = 0; index < unCheckedNames.length; index++) {
              const name = unCheckedNames[index];
              delete d[name];
            }
            if (this.legendOptions[0] !== 'Total') {
              this.groupByOptions = this.legendOptions.filter(o => o.active).map(o => o.name + '');
            }
          } else if (this.legendTitle === this.xAxis.name && !(this.xAxis.slug === 'year' && this.selectedChart === 'timeline')) {
            slug = this.xAxis.slug;
          } else if (this.legendTitle === this.yAxis.name) {
            slug = this.yAxis.slug;
          }

          return !slug || this.legendOptions.filter(o => o.active).map(o => o.name + '').includes(d[slug] + '');
        }
      } else {
        return true;
      }
    }.bind(this));

    /**
     * If data is grouped by ENT, calculate missing data
     */
    if (this.groupedBy.slug === 'ENT') {
      for (let index = 0; index < resultData.length; index++) {
        const element = resultData[index];
        element['Fuera del Área Metropolitana de Monterrey'] = element['Fuera AMM'];
        const groupedElements = _.toPairs(element).filter(function (o) {
          return _.includes(this.filterOptions['ENT'].options, o[0]);
        }.bind(this));
        if (this.filterOptions['unidad'].selected === 'Promedio') {
          element['Área Metropolitana de Monterrey'] = d3.mean(groupedElements.filter(
            o => o[0] !== 'Fuera del Área Metropolitana de Monterrey'), o => o[1]);
          element[NATIONAL] = d3.mean(groupedElements, o => o[1]);
        } else {
          element['Área Metropolitana de Monterrey'] = d3.sum(groupedElements.filter(
            o => o[0] !== 'Fuera del Área Metropolitana de Monterrey'), o => o[1]);
          element[NATIONAL] = d3.sum(groupedElements, o => o[1]);
        }
      }
    }
    return resultData;
  }
  /**
   * According to data Assign legend options to chart
   * @param dataToDraw Data is going to be displayed on chart
   */
  setLegendOptions(dataToDraw) {
    const vm = this;
    let legendBy = this.xAxis;
    if (this.yAxis.type === 'ordinal') {
      legendBy = this.yAxis;
    }
    if (this.groupedBy && this.groupedBy.slug) {
      legendBy = this.groupedBy;
    }
    // legendOptions by xAxis
    if (legendBy && legendBy.options) {
      this.legendOptions = legendBy.options.map(o => {
        return {
          active: true,
          name: o.name + '',
          slug: o.slug
        };
      });
      const selected = this.filterOptions[legendBy.slug].selected;
      if (!_.includes([ALL, BOTH, NATIONAL], selected)) {
        this.legendOptions = this.legendOptions.filter(o => o.name === selected);
      }
      if (legendBy.slug === 'date') {
        this.legendOptions = this.legendOptions.map(function (o) {
          if (moment(o.name).isValid()) {
            const d = moment(o.name).format('YYYY');
            return { name: d, slug: d, active: true };
          } else {
            return o;
          }
        }).filter(o => {
          return moment(o.name) >= moment(vm.filterOptions['dateStart'].selected) &&
            moment(o.name) <= moment(vm.filterOptions['dateEnd'].selected);
        }).reverse();
      }
    }
    this.legendTitle = legendBy.name;

    if (this.selectedChart === 'map') {
      // Get only municipalities that currently exist on data
      this.legendOptions = _.uniqBy(this.dataToDraw.filter(o => o['ENT'] !== 'Fuera AMM')
        .map(function (obj) {
          const key = obj.ENT;
          return {
            name: key,
            id: this.municipalitiesIds[key],
            active: true
          };
        }.bind(this)), 'id');
      this.legendOptions.unshift({ name: 'Fuera del Área Metropolitana de Monterrey', id: 0, slug: 'Fuera AMM', active: true });
      this.legendOptions.unshift({ name: 'Área Metropolitana de Monterrey', id: 1, slug: 'AMM', active: true });
      this.legendOptions.unshift({ name: NATIONAL, id: 18, slug: NATIONAL, active: true });
      this.legendTitle = 'UNIDAD GEOGRÁFICA';
    }
    this.colorCheckboxes();
  }
  /**
   * According to palette selected, and kind of answer, set checkboxes to corresponding colors
   */
  colorCheckboxes() {
    let colors = this.colors;
    if (colors.length > this.legendOptions.length) {
      colors = this.colors.slice(0, this.legendOptions.length).reverse();
    }
    setTimeout(function () {
      const selection = d3.selectAll('.checkbox-layout-tablet .mat-checkbox-background');
      if (selection.nodes().length > 0) {
        selection
          .style('background-color', function (d, i) {
            return colors[i % colors.length];
          }.bind(this));
      }
    }.bind(this), 0);
  }

  /**
   * Draw chart, only SVG DOM operations
   * @param {Array<IndicatorEntry>} dataToDraw - filtered data to be drawn
   */
  drawChart(dataToDraw) {
    const considerLegendOptions = true;
    this.filteredData = this.parseData(dataToDraw, considerLegendOptions);
    d3.select('.empty-chart').style('border', null);
  }

  /**
   * Change selected chart
   * @param index - Index from 1 to 6 of current chart selected
   */
  selectChart(chartName: string) {
    this.selectedChart = chartName;
    this.disabledXAxis = false;
    this.disabledYAxis = this.selectedChart === 'bars' ? true : false;
    this.setColorPalette();
    this.redirect();
  }
  /**
   * Toggles the visibility of showing the share option
   * @param showPanel bool to know if panel has to be shown
   */
  toggleShareOptions(showPanel) {
    this.sharePage = showPanel;
  }
  /**
   * Reads the vent from the button sort, and sor data of the chart according to option selected
   * @param prop Value of kind of ssort to apply to chart
   */
  sortChanged(prop) {
    const ordinalAxis = _.findIndex([this.xAxis, this.yAxis], o => o.type === 'ordinal');
    if (prop === 'names') {
      this.sortBy.names = true;
      this.sortBy.valuesAscending = false;
      this.sortBy.valuesDescending = false;
      this.orderBy = ordinalAxis === 1 ? this.yAxis.slug : this.xAxis.slug;
    } else if (prop === 'valuesAscending') {
      this.sortBy.names = false;
      this.sortBy.valuesAscending = true;
      this.sortBy.valuesDescending = false;
      this.orderBy = ordinalAxis === 1 ? this.xAxis.slug : this.yAxis.slug;
    } else if (prop === 'valuesDescending') {
      this.sortBy.names = false;
      this.sortBy.valuesAscending = false;
      this.sortBy.valuesDescending = true;
      this.orderBy = ordinalAxis === 1 ? this.xAxis.slug : this.yAxis.slug;
    }

    this.setLegendOptions(this.dataToDraw);
    this.drawChart(this.dataToDraw);
  }
  /**
   * Reads if aq checkbox was selected to quit that data of checkbox reporesenting
   * @param legendOptions Options of chart
   * @param legendName Name of legend
   */
  onLegendClickCheckbox(legendOptions, legendName) {
    let index = 0;
    legendOptions.find(function (element) {
      if (element.name === legendName) {
        legendOptions[index].active = !legendOptions[index].active;
      }
      index++;
    });
    this.onLegendClick(legendOptions);
  }
  /**
   * Call to rerender the chart after an option was selected
   * @param legendOptions LegendOptions selected by user
   */
  onLegendClick(legendOptions) {
    this.legendOptions = legendOptions;
    this.drawChart(this.dataToDraw);
  }
  /**
   * Reads the configuration of filters selected by user
   * Returns that configuration
   */
  filtersConfig() {
    const config = {
      names: {
        unidad: 'Unidad'
      },
      disabled: {
        unidad: {
          'Total': false,
          'Porcentaje': false,
          'Promedio': this.collapseBy && this.collapseBy.slug === this.selectedVariable.collapseBy
            && this.selectedChart !== 'heatmap' && this.selectedChart !== 'spineplot'
        }
      }
    };
    if (this.selectedVariable && this.selectedVariable.fieldOptions) {
      this.selectedVariable.fieldOptions.forEach(option => {
        if (!config.names[option.slug]) {
          config.names[option.slug] = option.name;
          config.disabled[option.slug] = false;
        }
      });
    }
    return config;
  }
  /**
   * Reads the configuration of second filters selected by user
   * Returns that configuration
   */
  secondFiltersConfig() {
    const config = {
      names: {
      },
      disabled: {
      }
    };
    if (this.secondSelectedVariable && this.secondSelectedVariable.fieldOptions) {
      this.secondSelectedVariable.fieldOptions.forEach(option => {
        if (!config.names[option.slug]) {
          config.names[option.slug] = option.name;
          config.disabled[option.slug] = false;
        }
      });
    }
    return config;
  }
  /**
   * Checks if chart is already rendered on compont and aliminates joyride
   * @param chart Not used parameter
   */
  onChartLoaded(chart) {
    // this.drawnChart = chart;
    d3.select('[joyridestep="step5"]').remove();
  }
  /**
   * Quit Suscribir to stop listening to Database
   */
  ngOnDestroy() {
    this.subQueryParams.unsubscribe();
  }
  /**
   * Read variable selected by user and quit special characters
   * Call functions to set the options and update chart
   * @param name Variable Selected
   */
  filterVariables(name: string) {
    if (typeof name === 'string') {
      return this.allVariables.filter(variable =>
        variable.name.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['indicator']) {
      if (this.selectedVariable.indicator !== name['indicator']) {
        // variable is a selected object
        this.selectedVariable = name;
        this.indicator = this.selectedVariable.indicator;

        this.setOptions();
        this.updateChart();
      }
      return this.allVariables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.name).indexOf(this.utils.stripSpecialCharacters(name['indicator'])) > -1);
    }
  }
  /**
   * Read variable selected by user and quit special characters
   * Call functions to set the options and update chart
   * @param name Variable Selected
   */
  filterSecondVariables(name: string) {
    if (typeof name === 'string') {
      return this.allVariables.filter(variable =>
        variable.name.toLowerCase().indexOf(name.toLowerCase()) > -1);
    } else if (name['indicator']) {
      if (this.secondSelectedVariable.indicator !== name['indicator']) {
        // variable is a selected object
        this.secondSelectedVariable = name;

        this.updateChart();
      }
      return this.allVariables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.name).indexOf(this.utils.stripSpecialCharacters(name['indicator'])) > -1);
    }
  }
  /**
   * Display a variable selected on Value from Autocomplete
   * @param variable Which variable is going to show on autocomplete
   */
  displayFn(variable?: Indicator): string | undefined {
    return variable ? variable.name : undefined;
  }
  /**
   * Display a variable selected on Value from Autocomplete
   * @param variable Which variable is going to show on autocomplete
   */
  displayFn2(variable?: Indicator): string | undefined {
    return variable ? variable.name : undefined;
  }
  /**
   * Sets the value of autocomplete  to null
   */
  eraseSearch() {
    this.searchVariable.setValue(undefined);
  }
  /**
   * Sets the value of autocomplete  to null
   */
  eraseSecondSearch() {
    this.searchSecondVariable.setValue(undefined);
  }
  /**
   * Sorts names of variables alphabetically
   * @param a name of first variable to compare
   * @param b name of second variable to compare
   */
  sortVariables(a, b) {
    return a.name.localeCompare(b.name, undefined, { numeric: true });
  }
  /**
   * Sorts names of groups alphabetically
   * @param a name of first group to compare
   * @param b name of second group to compare
   */
  sortGroups(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }
  /** Generate group items */
  generateGroupItems() {
    this.groupedByOptions = _.filter(this.axisOptions, item => {
      return item.type !== 'linear';
    });

    this.groupedByOptions.push({
      name: 'Sin desagregación',
      type: 'ordinal',
      slug: '',
      options: []
    });

    this.groupedByOptions = this.groupedByOptions.sort(this.sortGroups);
  }
  /** Generate selected filters with filter options available */
  generateSelectedFilters() {
    Object.keys(this.filterOptions).forEach(function (fk) {
      if (fk === 'unidad') {
        this.filterOptions[fk].selected = this.filterOptions[fk].options[0];
      } else if (this.filterOptions[fk].options[0]) {
        this.filterOptions[fk].selected = this.filterOptions[fk].options[0];
      } else {
        this.filterOptions[fk].selected = ALL;
      }
    }.bind(this));
  }
  /** Include if question is "Barreras de acceso" */
  includedIndicator() {
    return (this.selectedVariable && this.selectedVariable.name.indexOf('Barreras de acceso a información gubernamental') > -1);
  }
  /** Switch Miew if mobile or desktop  */
  switchDataView() {
    this.switchViewMob = !this.switchViewMob;
  }

  /** Screen width resizing listener */
  @HostListener('window:resize', ['$event'])
  /**
   * Reads if size of screen is changing
   * @param event Not used
   */
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 600) { // Lower than mobile screen width
      this.enableMobileMenu = true;
    } else {
      this.enableMobileMenu = false;
    }
  }
  /** Toggle Axes x - y and viceverse  */
  toggleAxes() {
    const tmpAxes = this.xAxisOptions;
    this.xAxisOptions = this.yAxisOptions;
    this.yAxisOptions = tmpAxes;
    const tmp = this.yAxis;
    this.yAxis = _.find(this.yAxisOptions, { slug: this.xAxis.slug });
    this.xAxis = _.find(this.xAxisOptions, { name: tmp.name });
    if (this.selectedChart === 'heatmap' || this.selectedChart === 'spineplot') {
      this.disabledYAxis = this.disabledXAxis = false;
      this.groupedBy = this.yAxis.type === 'ordinal' ? this.yAxis : _.find(this.groupedByOptions, { slug: '' });
    } else {
      this.disabledYAxis = !this.disabledYAxis;
      this.disabledXAxis = !this.disabledXAxis;
    }
    if (this.dataToDraw) {
      this.drawChart(this.dataToDraw);
    }
  }
  /** Show or hide labels */
  showLabels() {
    this.labelsVisible = !this.labelsVisible;
  }
  /** Show color palettes options available */
  showColors() {
    this.showColorsOptions = !this.showColorsOptions;
    this.showLabelsOptions = false;
  }
  /** Toggle stacked or grouped bars */
  toggleStackedOrGrouped() {
    this.stackBy = !this.stackBy;
    this.drawChart(this.dataToDraw);
  }
  /**
  * assign palette selected, to
  * @param palette Palette of colors selected
  */
  selectPalette(palette) {
    this.colors = palette;
    if (this.dataToDraw) {
      this.drawChart(this.dataToDraw);
    }
  }
  /**
   * return true if color intersection is bigger than 5
   * @param palette palette of colors selected
   */
  paletteIsSelected(palette) {
    return _.intersection(this.colors, palette).length > 5;
  }
}



// WEBPACK FOOTER //
// ./src/app/enadis-compare/enadis-compare-graphs/enadis-compare-graphs.component.ts